// path: src/Components/story/StoryLevelMap.js

import React from "react";
import StoryBoardMap from "./StoryBoardMap";

export default function StoryLevelMap({
    progress,
    onPlayLevel,
    header = null,
    initialMapPage = "surface",
}) {
    return (
        <div className="storyLevelMap" aria-label="Story worlds and levels">
            <StoryBoardMap
                progress={progress}
                onPlayLevel={onPlayLevel}
                header={header}
                initialMapPage={initialMapPage}
            />
        </div>
    );
}
